import * as actionTypes from 'js/constants/actionTypes';
import { POST } from 'js/constants/requestMethods';
import { CALL_PRIVATE_API } from 'js/middleware/api';
import { pipelineSchema } from 'js/schemas';
import { refreshPipeline } from 'js/actions/pipelines';

type RestorePipelineOptions = {
  activate_after_restore?: boolean;
  ignoreErrors?: boolean;
};
/**
 * Restores an archived flow by calling the adminApi `/flows/{flowNodeId}/archival/restore` endpoint and refreshing the pipeline
 * admin API PR: admin-api/pull/2046
 */
export const restorePipeline =
  (flowNodeId: number | string, options?: RestorePipelineOptions) =>
  (dispatch: any, getState: any) => {
    const {
      app: {
        listing: { aclQueryMode },
      },
    } = getState();

    // `ignoreErrors` is a request-level flag, not part of the restore body.
    const { ignoreErrors, ...restoreBody } = options ?? {};

    const payload = {
      activate_after_restore: false,
      ...restoreBody,
    };

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.RESTORE_PIPELINE_REQUEST,
          actionTypes.RESTORE_PIPELINE_SUCCESS,
          actionTypes.RESTORE_PIPELINE_FAILURE,
        ],
        endpoint: `/flows/${flowNodeId}/archival/restore`,
        schema: pipelineSchema,
        requestMethod: POST,
        aclQueryMode,
        payload,
        ignoreErrors,
      },
    }).then(() => dispatch(refreshPipeline(flowNodeId, { ignoreErrors })));
  };
